import { render, staticRenderFns } from "./StudyInstituteTable.vue?vue&type=template&id=2b024851"
import script from "./StudyInstituteTable.vue?vue&type=script&lang=ts"
export * from "./StudyInstituteTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports